module.exports = __webpack_public_path__ + "img/testimony.024e4144.jpg";